import { Box, Paper, Stack, Typography } from '@mui/material'

const BAR_HEIGHT = 300
const LAST_DAY = 366

// Palette generated for planting & harvest date rasters.
// Explanation & source in './colors_365_maxspread.html
const STOPS = [
  { day: 1, color: 'rgb(153,10,10)', label: 'Jan' },
  { day: 32, color: 'rgb(172,90,12)', label: 'Feb' },
  { day: 60, color: 'rgb(189,170,18)', label: 'Mar' },
  { day: 91, color: 'rgb(131,207,17)', label: 'Apr' },
  { day: 121, color: 'rgb(25,224,19)', label: 'May' },
  { day: 152, color: 'rgb(31,234,130)', label: 'Jun' },
  { day: 182, color: 'rgb(50,235,232)', label: 'Jul' },
  { day: 213, color: 'rgb(70,154,236)', label: 'Aug' },
  { day: 244, color: 'rgb(91,90,237)', label: 'Sep' },
  { day: 274, color: 'rgb(185,109,238)', label: 'Oct' },
  { day: 305, color: 'rgb(239,128,220)', label: 'Nov' },
  { day: 335, color: 'rgb(241,147,178)', label: 'Dec' },
]

const pct = (day: number) => `${(((day - 1) / (LAST_DAY - 1)) * 100).toFixed(1)}%`

// Explicit percentage stops so the gradient matches the palette precisely.
const GRADIENT = `linear-gradient(to bottom, ${[
  ...STOPS,
  { day: LAST_DAY, color: 'rgb(243,173,165)' },
]
  .map(s => `${s.color} ${pct(s.day)}`)
  .join(', ')})`

export const HarvestDateLegend = () => {
  return (
    <Paper sx={{ p: 1, mt: 1 }}>
      <Stack spacing={0.5}>
        <Typography variant="caption" fontWeight="bold">
          Harvest Date
        </Typography>
        <Stack direction="row" spacing={0}>
          {/* Gradient bar */}
          <Box sx={{ width: 16, height: BAR_HEIGHT, background: GRADIENT, flexShrink: 0 }} />
          {/* Tick marks and month labels, absolutely positioned to align with gradient */}
          <Box sx={{ position: 'relative', height: BAR_HEIGHT, minWidth: 40 }}>
            {STOPS.map(({ day, label }) => {
              const top = ((day - 1) / (LAST_DAY - 1)) * BAR_HEIGHT
              return (
                <Box
                  key={label}
                  sx={{
                    position: 'absolute',
                    top,
                    left: 0,
                    display: 'flex',
                    alignItems: 'center',
                    transform: 'translateY(-50%)',
                  }}
                >
                  <Box
                    sx={{
                      width: 5,
                      height: '1.5px',
                      bgcolor: 'text.primary',
                      mr: 0.5,
                      flexShrink: 0,
                    }}
                  />
                  <Typography variant="body2" sx={{ fontSize: '0.7rem', lineHeight: 1 }}>
                    {label}
                  </Typography>
                </Box>
              )
            })}
          </Box>
        </Stack>
      </Stack>
    </Paper>
  )
}
